<template>
  <ion-page>
    <ion-content class="ion-padding-top bg-grad-content search-list">
      <div class="padding-top-xl">
        <ion-searchbar
          v-model="search"
          ref="searchbar"
          searchIcon="none"
          placeholder="buscar producto"
          animated
          @keyup.enter="getSearch"
        >
          <ion-button color="medium" size="small" @click="getSearch"
            ><ion-icon slot="icon-only" name="search"></ion-icon></ion-button
        ></ion-searchbar>
      </div>

      <ion-list v-if="products.length > 0" style="margin-bottom: 50px">
        <ion-item v-for="(item, index) in products" :key="index" lines="none">
          <ion-card>
            <img
              v-lazy="item.mainimage.data.imagen"
              width="800"
              @click="zoomImage(item.mainimage.data.imagen)"
            />
            <ion-card-header>
              <ion-card-subtitle>{{
                `${item.mdmoto} - ${item.mcmoto}`
              }}</ion-card-subtitle>
              <ion-card-title>{{ item.nombre }}</ion-card-title>
              <ion-text color="secondary">
                <h3>{{ $filters.currencyFormat(item.precio) }}</h3>
              </ion-text>
            </ion-card-header>
            <ion-card-content>
              {{ item.descripcion }}
            </ion-card-content>
            <ion-footer>
              <ion-row>
                <ion-col
                  class="ion-text-center"
                  @click="addProductToCart(item)"
                >
                  <i class="mdi mdi-cart-plus mdi-36px"></i>
                </ion-col>
                <ion-col class="ion-text-center" @click="likeProduct(item)">
                  <i class="mdi mdi-briefcase-check-outline mdi-36px"></i>
                </ion-col>
                <ion-col
                  class="ion-text-center"
                  @click="
                    goWhatsApp(
                      `Hola, quiero información sobre: ${item.mdmoto} - ${item.mcmoto}, ${item.nombre}`
                    )
                  "
                  ><i class="mdi mdi-whatsapp mdi-36px color-green"></i>
                </ion-col>
                <ion-col
                  class="ion-text-center"
                  @click="$router.push(item.url)"
                >
                  <i class="mdi mdi-location-enter mdi-36px"></i>
                </ion-col>
              </ion-row>
            </ion-footer>
          </ion-card>
        </ion-item>
      </ion-list>
      <ion-infinite-scroll
        v-if="isDisabled"
        @ionInfinite="goNextPage($event)"
        threshold="100px"
        id="infinite-scroll"
      >
        <ion-infinite-scroll-content
          loading-spinner="bubbles"
          loading-text="Cargando mas datos..."
        >
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
  </ion-page>
</template>

<script>
import _ from 'lodash'
export default {
  components: {},
  // eslint-disable-next-line no-unused-vars
  data(vm) {
    return {
      search: '',
      products: [],
      isDisabled: false,
      nextPage: ''
    }
  },
  ionViewDidEnter() {
    this.$store.dispatch('app/keepPageState', false)
    this.$emitter.emit('full-loader')
  },
  ionViewDidLeave() {},
  ionViewWillEnter() {
    if (!this.$store.getters['app/keepPageState']) {
      this.$emitter.emit('full-loader', { open: true })
    }
  },
  ionViewWillLeave() {
    if (!this.$store.getters['app/keepPageState']) {
      this.isDisabled = false
      this.products = []
      this.nextPage = ''
      this.search = ''
    }
  },
  mounted() {},
  computed: {},
  watch: {
    search: _.debounce(function() {
      if (this.search.length == 0) {
        this.products = []
        this.isDisabled = false
      }
    }, 500)
  },
  methods: {
    async zoomImage(image) {
      this.$store.dispatch('app/keepPageState', true)
      this.$store.dispatch('app/imageToView', image)
      this.$router.push({ name: 'view-image' })
    },
    goWhatsApp(text) {
      window.open(`https://wa.me/573213813097?text=${text}`, '_blank')
    },
    addProductToCart(product) {
      product.slug = product.url
      product.main_image = product.mainimage.data.imagen
      product.ref = `${product.mcmoto} - ${product.mdmoto}`
      this.$store.dispatch('cart/addProductToCart', product)
      this.$emitter.emit('toast', {
        message: 'Producto agregado al carro',
        color: 'primary'
      })
    },
    likeProduct(item) {
      let product = {
        id: item.id,
        name: item.nombre,
        image: item.mainimage.data.imagen,
        price: item.precio,
        ref: `${item.mcmoto} - ${item.mdmoto}`,
        slug: item.url,
        qty: 1
      }
      let mdmoto = {
        descripcion: item.mdmoto,
        marcamoto: {
          data: {
            descripcion: item.mcmoto
          }
        }
      }
      this.$store.dispatch('app/messageData', {
        title: 'Quiero Comprar',
        product: product,
        mdmoto: mdmoto
      })
      this.$store.dispatch('app/keepPageState', true)
      this.$router.push({ name: 'messageme' })
    },
    getSearch() {
      this.products = []
      this.$refs.searchbar.$el.children[1].children[0].blur()
      if (this.search.length > 0) {
        this.isDisabled = false
        this.$emitter.emit('full-loader', { open: true })
        this.$http
          .get('app-mobile/search', {
            params: { search_criteria: this.search }
          })
          .then((res) => {
            this.products = res.data.data
            if (res.data.meta.pagination.total_pages > 1) {
              this.isDisabled = true
              this.nextPage = res.data.meta.pagination.links.next
            }
            this.$emitter.emit('full-loader', { open: false })
          })
          .catch((err) => {
            this.$emitter.emit('full-loader', { open: false })
          })
      } else {
        this.products = []
        this.isDisabled = false
      }
    },
    goNextPage(infiniteScroll) {
      this.$http
        .get(this.nextPage, { params: { search_criteria: this.search } })
        .then((res) => {
          this.products = this.products.concat(res.data.data)
          if (res.data.meta.pagination.links.next) {
            this.nextPage = res.data.meta.pagination.links.next
            this.isDisabled = true
          } else this.isDisabled = false
          infiniteScroll.target.complete()
        })
        .catch((err) => {})
    }
  }
}
</script>

<style>
.search-list .list-ios {
  background: transparent;
}
.search-list .list-md {
  background: transparent;
}
.search-list .item-native {
  background: transparent;
}

.search-list ion-item {
  --background: transparent;
  --border-color: transparent;
}
</style>
